import { Component, OnInit } from '@angular/core';
import { GatesService } from '../_services/gates.service';
import { GlobalService } from 'src/app/_services/global.service';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { AutoUnsubscribe } from 'src/app/shared/decorators/auto-unsubscribe.decorator';
import { distinctUntilChanged, Subject, takeUntil, tap } from 'rxjs';
declare var $: any;
@AutoUnsubscribe
@Component({
  selector: 'app-gates',
  templateUrl: './gates.component.html',
  styleUrls: ['./gates.component.scss']
})
export class GatesComponent implements OnInit {
  gates = [];
  guards = [];
  overviewData;
  loading = true;
  currLang;
  compactView;
  rowsView = "compact";
  tableControls: any = { data: [] };
  dataArray;
  destroy$ = new Subject<void>(); 
  constructor(
    private gatesService: GatesService,
    private translate: TranslateService,
    private dataService: DataService,
    private globalService: GlobalService) {
      this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng =>{
        //console.log('(c)gates_(f)getLang_(L)32' , lng);
        this.currLang = lng;
        this.translate.use(this.currLang);
      });
    }

  ngOnInit(): void {
        // to remove the black screen and the stuck error msg popup if error message was just closed in sibling component 
        $('.modal').modal('hide');
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();  
    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng =>{
      //console.log('(c)gates_(f)getLang_(L)44' , lng);
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.getAllGates();
    this.gatesService.getGatesReload().pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)gates_(f)getGatesReload_(L)50' , res);
      if (res) {
        this.getAllGates();
      }
    })
    // this.globalService.getLoading().pipe(takeUntil(this.destroy$)).subscribe(res => {
    //   this.loading = res;
    // })

    this.dataService.getRowsStyle().pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      //console.log('(c)gates_(f)getRowsStyle_(L)60' , res);
            this.compactView = res;
            this.rowsView = res ? "compact" : "list";
            this.translate.get("init").pipe(takeUntil(this.destroy$)).subscribe((res) => {
              //console.log('(c)gates_(f)translateInit_(L)64' , res);
              this.setTableData();
            });
            // this.translate.onLangChange.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            //   this.setTableData();
            // });
            this.translate.onLangChange.pipe(
              distinctUntilChanged((prev, curr) => prev.lang === curr.lang), // Only trigger if the language changes
              tap((res) => {
                //console.log('(c)gates_(f)translateOnChange_(L)74' , res);
                this.setTableData();
              }),
              takeUntil(this.destroy$) // Automatically unsubscribe when destroy$ emits
            )
            .subscribe();
          });  
  }

  getAllGates() {
    // this.globalService.startLoading();
    this.loading = true;
    this.guards = [];
    this.dataService.getAllGates().pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      //console.log('(c)gates_(f)getAllGates_(L)79' , res);
      this.gates = res;
      
      this.gates.map(gate => {
        gate.users.map(user => {
          if (!this.guards.includes(user.id)) {
            this.guards.push(user.id)
          }
        })
      // remove dublicates grades objects from the grades array if it has values.
      if(gate.grades){
        gate.grades.length > 0 ? gate.grades = [...new Map(gate.grades.map((grade) => [grade['id'], grade])).values()]:'';
      }
      })
      this.setOverviewData(this.gates, this.guards);
      this.dataArray = this.gates.map((gate) => ({
                name: gate.name,
                noOfGrades: gate.grades?.length,
                noOfGuards: gate.users?.length,
                id:gate.id,
                area:gate.area
              }));
      // this.globalService.stopLoading();
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    })
  }


  setOverviewData(gates, guards) {
    const gatesErrors = gates.map(gate => {
      return {
        count: 0,
        countFlag: false,
        name: gate.name,
        statesFlag: true,
        error: gate.users.length === 0 ? true : null
      }
    })
    // here
    this.translate.get('init').pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)gates_(f)translateInit_(L)121' , res);
      this.overviewDataList(gatesErrors,gates, guards);
    });
    // this.translate.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(res => {
    //   this.overviewDataList(gatesErrors,gates, guards);
    // })

    this.translate.onLangChange.pipe(
      distinctUntilChanged((prev, curr) => prev.lang === curr.lang), // Only trigger if the language changes
      tap((res) => {
      //console.log('(c)gates_(f)translateOnChange_(L)141' , res);
      this.overviewDataList(gatesErrors,gates, guards);
      }),
      takeUntil(this.destroy$) // Automatically unsubscribe when destroy$ emits
    )
    .subscribe();
  }
  overviewDataList(gatesErrors,gates,guards){
    this.overviewData = [
      {
        header: this.translate.instant('gates.errors'),
        content: gatesErrors
      },
      {
        header: this.translate.instant('gates.gates-guards'),
        content: [{
          count: gates.length,
          countFlag: true,
          name: this.translate.instant('gates.gates'),
          statesFlag: false,
          error: null
        }, {
          count: guards.length,
          countFlag: true,
          name: this.translate.instant('gates.guards'),
          statesFlag: false,
          error: null
        }]
      }
    ]
  }
  overviewEventHandler(event) {
    // console.log(event);
  }

  addGate() {
    $("#addGateModal").modal("show");
  }

  setTableData() {
        this.tableControls = {
          selection: false,
          paging: false,
          view: "list",
          columns: [
            {
              name: this.translate.instant("gates.add-gate-modal.gate-name"),
              sort: false,
              type: "string",
              source: "name",
            },
            {
              name: this.translate.instant("gates.add-gate-modal.green-zone"),
              sort: false,
              type: "string",
              source: "area",
            },
            {
              name: this.translate.instant("gates.grades-count"),
              sort: false,
              type: "string",
              source: "noOfGrades",
            },
            {
              name: this.translate.instant("gates.guards-count"),
              sort: false,
              type: "string",
              source: "noOfGuards",
            },
            {
              name: this.translate.instant('table-view.edit'),
              type: "editIcon",
            },
            // {
            //   name: "waiting time",
            //   sort: false,
            //   type: "string",
            //   source: "waitingTime"
            // }
          ],
          data: this.dataArray,
        };
      }

      editListViewGate(e, gate) {
            e.stopPropagation();
            this.gatesService.getGate(gate.id).pipe(takeUntil(this.destroy$)).subscribe(res => {
              //console.log('(c)gates_(f)editListViewGate_(L)209' , res);
              this.gatesService.setGateData(res);
              $("#addGateModal").modal("show");
              $(`#addGateModal .modal-body`)[0].scrollTop = 0;
            })
          }
        tableEventHandeler(event) {
            switch (event.action) {
              case "rowClicked":
                break;
              case "iconClicked":
                this.editListViewGate(event.e, event.target.data);
                break;
              case "checkboxChanged":
                // this.selectChanged(event.target);
                break;
              case "sorting":
                // this.toggleSorting(event.target.source);
                break;
              case "pagination":
                // this.paginationHandling(event.target);
                break;
            }
          }

          ngOnDestroy(): void {
          }
}
